import React, { useState } from 'react';
import '../css/Profile.css';

const Profile = ({ user, onLogout, setUser }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const [editData, setEditData] = useState({
        name: user?.name || '',
        lastname: user?.lastname || '',
        password: '',
        confirmPassword: ''
    });

    // Используем переменную окружения
    const BASE_URL = process.env.REACT_APP_API_URL || 'https://church.info-roman-b.workers.dev';

    const handleSave = async () => {
        if (editData.password && editData.password !== editData.confirmPassword) {
            alert("Пароли не совпадают!");
            return;
        }

        const payload = {
            id: user.id,
            name: editData.name,
            lastname: editData.lastname
        };

        if (editData.password) payload.password = editData.password;

        try {
            const res = await fetch(`${BASE_URL}/update-profile`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (res.ok) {
                const result = await res.json();
                localStorage.setItem('user', JSON.stringify(result.user));
                setUser(result.user);
                setIsEditing(false);
                alert("Профиль обновлен!");
            }
        } catch (error) {
            console.error("Ошибка обновления профиля:", error);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('user');
        if (onLogout) onLogout(null);
    };

    const handleAvatarChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const MAX_WIDTH = 300;
                const scaleSize = MAX_WIDTH / img.width;
                canvas.width = MAX_WIDTH;
                canvas.height = img.height * scaleSize;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                canvas.toBlob(async (blob) => {
                    try {
                        const res = await fetch(`${BASE_URL}/upload-avatar?id=${user.id}`, {
                            method: 'POST',
                            body: blob
                        });

                        if (res.ok) {
                            const data = await res.json();
                            // Добавляем метку времени к URL, чтобы обойти кеш браузера
                            const updatedUser = { ...user, avatar: `${data.avatarUrl}&t=${Date.now()}` };
                            setUser(updatedUser);
                            localStorage.setItem('user', JSON.stringify(updatedUser));
                        }
                    } catch (error) {
                        console.error("Ошибка загрузки аватара:", error);
                    } finally {
                        setIsUploading(false);
                    }
                }, 'image/webp', 0.8);
            };
        };
    };
    return (
        <div className="Profile">
            <div className="Profile_card">
                {isEditing ? (
                    <div className="edit_fields">
                        <h2>Надстройки</h2>
                        <div className="edit_fields_inputs">
                            <input type="text" placeholder="Имя" value={editData.name}
                                   onChange={e => setEditData({...editData, name: e.target.value})}/>
                            <input type="text" placeholder="Фамилия" value={editData.lastname}
                                   onChange={e => setEditData({...editData, lastname: e.target.value})}/>
                            <hr/>
                            <p className="small_hint">*Оставьте пустым, если не хотите менять пароль</p>
                            <input type="password" placeholder="Новый пароль" value={editData.password}
                                   onChange={e => setEditData({...editData, password: e.target.value})}/>
                            <input type="password" placeholder="Подтвердите пароль" value={editData.confirmPassword}
                                   onChange={e => setEditData({...editData, confirmPassword: e.target.value})}/>

                            <div className="profile_btns">
                                <button className="save_btn" onClick={handleSave}>Сохранить</button>
                                <button className="cancel_btn" onClick={() => setIsEditing(false)}>Отмена</button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="user_info">
                        <div className="avatar_container">
                            <div
                                className={`User_img ${isUploading ? 'loading' : ''}`}
                                style={{
                                    backgroundImage: `url(${user.avatar || `${BASE_URL}/avatar?id=${user.id}`}), url('https://via.placeholder.com/150')`
                                }}
                            >
                                {isUploading && <div className="loader"></div>}
                            </div>

                            {/* Кнопка смены фото */}
                            <label className="edit_photo_btn">
                                <input type="file" accept="image/*" onChange={handleAvatarChange} hidden/>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round">
                                    <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"/>
                                    <path d="M13.5 6.5l4 4"/>
                                </svg>
                            </label>
                        </div>

                        <div className="Name">{user.name} {user.lastname}</div>

                        <div className="profile_actions">
                            <button className="settings_btn" onClick={() => setIsEditing(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round"
                                     className="">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path
                                        d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065"/>
                                    <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/>
                                </svg>
                            </button>
                            <button className="logout_btn" onClick={handleLogout}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                     strokeLinejoin="round"
                                     className="">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M13 12v.01"/>
                                    <path d="M3 21h18"/>
                                    <path d="M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"/>
                                    <path d="M14 7h7m-3 -3l3 3l-3 3"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Profile;